/* @flow */

import axios, { type AxiosPromise } from 'axios';

import { API } from './constants';

import { type RespostaUpload } from './types';
import getTokenApi from '../login/get-token-api';


const postFormData = (url: string, form: FormData): AxiosPromise<RespostaUpload> => axios
    .post(url, form, {
        baseURL: API,
        headers: {
            Authorization: getTokenApi(),
        },
    });

const uploadFile = (file: File, url: string) => {
    const form = new FormData();
    form.append('foto', file);
    return postFormData(url, form);
};

export default uploadFile;
